// src/pages/VendorDashboard.jsx
import React from "react";
import { Link } from "react-router-dom";

/**
 * Props optionnelles :
 * - userDoc : document Firestore du vendeur (users/uid)
 *   (si tu as un contexte Auth, tu peux lui passer ici)
 */
export default function VendorDashboard({ userDoc }) {
  const shopName = userDoc?.shopName || "Mon espace vendeur";
  const packName = userDoc?.packName || (userDoc?.packId === "pro" ? "Pack Professionnel" : "Pack Standard");
  const subscriptionStatus = userDoc?.subscriptionStatus || "active";

  const statusLabel =
    subscriptionStatus === "pending_payment"
      ? "En attente de paiement"
      : subscriptionStatus === "expired"
      ? "Abonnement expiré"
      : "Abonnement actif";

  const statusClass = `vd-status vd-status-${subscriptionStatus}`;

  // Menu de cards
  const MENU_CARDS = [
    {
      id: "Profil",
      title: "Edition",
      desc: "Mettre à jour votre profil GoShop.",
      to: "/vendor/profil",
    },
    {
      id: "products",
      title: "Mes produits",
      desc: "Ajouter, modifier ou désactiver vos produits GoShop.",
      to: "/vendor/products",
    },
    {
      id: "orders",
      title: "Commandes",
      desc: "Suivre les commandes, statuts de livraison et paiements.",
      to: "/vendor/orders",
    },
    {
      id: "subscription",
      title: "Abonnement & facturation",
      desc: "Voir votre pack, renouveler ou changer d’abonnement.",
      to: "/vendor/abonnement",
    },
    {
      id: "stats",
      title: "Statistiques",
      desc: "Consulter vos ventes, produits les plus vus et best-sellers.",
      to: "/vendor/stats",
    },
    {
      id: "store",
      title: "Ma boutique",
      desc: "Logo, bannière, infos boutique et horaires d’ouverture.",
      to: "/vendor/store-settings",
    },
    {
      id: "sponsored-deals",
      title: "Offres sponsorisées",
      desc: "Gérer vos offres promotionnelles et campagnes publicitaires.",
      to: "/vendor/sponsored",
    },
    {
      id: "support",
      title: "Support GoShop",
      desc: "Contacter l’équipe GoShop pour toute assistance.",
      to: "/vendor/support",
    },
  ];

  return (
    <div
      style={{
        // minHeight: "100vh",
        // background: "#f3f4f6",
        display: "flex",
        justifyContent: "center",
        padding: "24px 16px 40px",
      }}
    >
      <main
        style={{
          width: "100%",
          maxWidth: "1120px",
          fontSize: "14px",
          lineHeight: 1.5,
        }}
      >
        {/* En-tête du dashboard */}
        <header
          style={{
            marginBottom: 16,
          }}
        >
          <h1
            style={{
              fontSize: 24,
              fontWeight: 800,
              color: "#0f172a",
              marginBottom: 4,
            }}
          >
            Dashboard vendeur
          </h1>
          <p
            style={{
              fontSize: 13,
              color: "#4b5563",
              marginBottom: 10,
            }}
          >
            Bienvenue sur votre espace vendeur GoShop. Gérez vos produits, vos
            commandes et votre abonnement depuis un seul endroit.
          </p>

          <div
            style={{
              background: "#ffffff",
              borderRadius: 18,
              border: "1px solid #e5e7eb",
              padding: 14,
              display: "flex",
              flexWrap: "wrap",
              gap: 10,
              alignItems: "center",
              justifyContent: "space-between",
              boxShadow: "0 10px 25px rgba(15,23,42,0.06)",
            }}
          >
            <div>
              <div
                style={{
                  fontSize: 16,
                  fontWeight: 700,
                  color: "#111827",
                }}
              >
                {shopName}
              </div>
              <div
                style={{
                  fontSize: 13,
                  color: "#6b7280",
                  marginTop: 2,
                }}
              >
                {packName}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 8,
                alignItems: "center",
              }}
            >
              <span className={statusClass}>{statusLabel}</span>

              <Link
                to="/vendor/abonnement"
                className="vd-btn-light"
              >
                Gérer mon abonnement
              </Link>
            </div>
          </div>
        </header>

        {/* Grille de cards menu */}
        <section>
          <h2
            style={{
              fontSize: 18,
              fontWeight: 700,
              color: "#111827",
              marginBottom: 10,
            }}
          >
            Menu principal
          </h2>

          <div className="vd-grid">
            {MENU_CARDS.map((card) => (
              <Link key={card.id} to={card.to} className="vd-card-link">
                <article className="vd-card">
                  <div className="vd-card-header">
                    <div className="vd-card-icon">
                      {/* simple icône texte (tu pourras remplacer par de vraies icônes plus tard) */}
                      {card.title.charAt(0)}
                    </div>
                    <h3 className="vd-card-title">{card.title}</h3>
                  </div>
                  <p className="vd-card-desc">{card.desc}</p>
                  <div className="vd-card-footer">
                    <span>Accéder</span>
                    <span className="vd-card-arrow">→</span>
                  </div>
                </article>
              </Link>
            ))}
          </div>
        </section>

        <style>{`
          .vd-grid {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 16px;
          }

          @media (max-width: 1024px) {
            .vd-grid {
              grid-template-columns: repeat(2, minmax(0, 1fr));
            }
          }

          @media (max-width: 640px) {
            .vd-grid {
              grid-template-columns: minmax(0, 1fr);
            }
          }

          .vd-card-link {
            text-decoration: none;
          }

          .vd-card {
            height: 100%;
            background: #ffffff;
            border-radius: 18px;
            border: 1px solid #e5e7eb;
            padding: 14px 14px 12px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            box-shadow: 0 10px 24px rgba(15,23,42,0.06);
            transition:
              box-shadow 0.18s ease,
              transform 0.18s ease,
              border-color 0.18s ease;
          }

          .vd-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 18px 40px rgba(15,23,42,0.12);
            border-color: #c7d2fe;
          }

          .vd-card-header {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-bottom: 8px;
          }

          .vd-card-icon {
            width: 30px;
            height: 30px;
            border-radius: 999px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #eff6ff;
            color: #1d4ed8;
            font-size: 14px;
            font-weight: 700;
          }

          .vd-card-title {
            font-size: 15px;
            font-weight: 700;
            color: #111827;
            margin: 0;
          }

          .vd-card-desc {
            font-size: 13px;
            color: #4b5563;
            margin: 0 0 10px;
          }

          .vd-card-footer {
            margin-top: auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            color: #1d4ed8;
            font-weight: 600;
          }

          .vd-card-arrow {
            font-size: 14px;
          }

          /* Badge statut abonnement */
          .vd-status {
            display: inline-flex;
            align-items: center;
            padding: 4px 10px;
            border-radius: 999px;
            font-size: 11px;
            font-weight: 600;
            text-transform: none;
          }
          .vd-status-active {
            background: #dcfce7;
            color: #166534;
          }
          .vd-status-pending_payment {
            background: #fef9c3;
            color: #92400e;
          }
          .vd-status-expired {
            background: #fee2e2;
            color: #b91c1c;
          }

          /* Bouton abonnement */
          .vd-btn-light {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 7px 14px;
            border-radius: 999px;
            border: 1px solid #d1d5db;
            background: #ffffff;
            color: #111827;
            font-size: 12px;
            font-weight: 600;
            text-decoration: none;
            transition:
              background 0.15s ease,
              border-color 0.15s ease,
              color 0.15s ease;
          }
          .vd-btn-light:hover {
            background: #f3f4f6;
            border-color: #9ca3af;
          }
        `}</style>
      </main>
    </div>
  );
}
